import { render, staticRenderFns } from "./consumer-form.vue?vue&type=template&id=2828c1e2"
import script from "./consumer-form.vue?vue&type=script&lang=ts"
export * from "./consumer-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports